import * as React from "react";
import {connect} from "react-redux";
import SpecialsComponent from "../components/SpecialsComponent";
import {MouseEvent} from "react";
import {push} from "react-router-redux";
import {SpecialsRoutes} from "../../routes";
import {mySpecialsSelector} from "../selectors";
import {fetchSpecialsByUser, fetchExpiredSpecialsByUser, fetchLikedSpecialsByUser} from "../middlewares";
import {clearSpecials} from "../actions";
import {currentPathSelector} from "../../_helpers/routerSelectors";
import {specialByIdSelector} from "../../_data/selectors";
import Meta from "../../_data/models/Meta";

const mapStateToProps = (state, ownProps) => {   
    const specials = mySpecialsSelector(state).ids.map(id=>{
        return specialByIdSelector(state, id);
    });      

    return {
        items: specials,
        loading: mySpecialsSelector(state).loading,
        meta: mySpecialsSelector(state).meta,
        errors: mySpecialsSelector(state).errors,
        currentPath: currentPathSelector(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {    
    return {
        dispatch: dispatch, 
        viewSpecials: (specialType: string) => {     
            dispatch(clearSpecials());
            switch (specialType) {
                case "liked":                      
                    dispatch(fetchLikedSpecialsByUser());
                    break;
                case "expired":                    
                    dispatch(fetchExpiredSpecialsByUser());                    
                    break;     
                default: 
                    dispatch(fetchSpecialsByUser());
                    dispatch(push(SpecialsRoutes.index()));
                    return;                           
            }
            dispatch(push(SpecialsRoutes.tab(specialType)));
        },
        loadMore: (meta: Meta, currentPath: string) => {
            if (meta && meta.hasNext()) {                
                 switch (currentPath) {
                    case SpecialsRoutes.tab('liked'):                      
                        dispatch(fetchLikedSpecialsByUser(meta.cursor, meta.nextPage));
                        break;
                    case SpecialsRoutes.tab('expired') :                    
                        dispatch(fetchExpiredSpecialsByUser(meta.cursor, meta.nextPage));                    
                        break;     
                    default: 
                        dispatch(fetchSpecialsByUser(meta.cursor, meta.nextPage));                                                                    
                    return
                }
            }
        }    
    }
};
const SpecialsContainer = connect(mapStateToProps, mapDispatchToProps)(SpecialsComponent);
export default SpecialsContainer;


// WEBPACK FOOTER //
// ./app/client/special/containers/SpecialsContainer.tsx